export default __webpack_public_path__ + "static/media/round-ligament.c03bc5aa.png";